import { Table } from "rsuite";
import { useState } from "react";
import { SvgEdit } from "../../assets/icons";
import { SvgBin } from "../../assets/icons";
import { CellProps, Toggle } from "rsuite";
import { CustomModal } from "../modal/customModal.component";
import { Link } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { ApiAdmin } from "../../core/apis/admin";
import { showSuccessToast, showErrorToast } from "../generic/toast.component";
import { useNavigate } from "react-router-dom";
const { Cell } = Table;

export const ActionCell = ({
  rowData,
  onChange,
  onDeleteChange,
  ...props
}: CellProps & {
  onChange: (id: string, isActive: boolean) => void;
  onDeleteChange: (id: string) => void;
}) => {
  const navigate = useNavigate();
  const [statusLoading, setStatusLoading] = useState(false);

  const handleActiveStatus = async (id: string) => {
    setStatusLoading(true);
    try {
      await ApiAdmin.activeStatus(id, !rowData.IsActive);
      onChange(id, !rowData.IsActive);
      navigate(AppRoutesUI.Admins.AdminList());
      if (rowData.IsActive === true) {
        showSuccessToast("Admin Deactivated successfully");
      } else {
        showSuccessToast("Admin Activated successfully");
      }
    } catch (error: any) {
      showErrorToast(error.response?.data?.Message || error.message);
    }
    setStatusLoading(false);
  };

  return (
    <Cell {...props}>
      <div className="d-flex align-items-center justify-content-center ms-3 px-5">
        <Link
          to={AppRoutesUI.Admins.AdminEditById(rowData.Id)}
          state={rowData.Id}
          className="me-2"
        >
          <SvgEdit />
        </Link>
        <CustomModal
          component={<SvgBin />}
          title="Delete Admin"
          okButton="Delete"
          onOk={() => onDeleteChange(rowData.Id)}
        >
          <div>
            <p>Are you sure you want to delete this Admin?</p>
          </div>
        </CustomModal>
        <Toggle
          onChange={() => handleActiveStatus(rowData.Id)}
          checked={rowData.IsActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          className="ms-2"
          loading={statusLoading}
        />
      </div>
    </Cell>
  );
};
